
    <div class="btn-group btn-group-sm navbar-btn">
      <button [ngClass]="['btn btn-default', 'btn-value-' + button.value, button.value]"
        *ngFor="let button of buttons"
        [class.active]="isSelectedButton(button.value)"
        (click)="buttonClick.next(button)">
        {{ button.label }}
      </button>
    </div>
  